/**
 * Copyright © 2025 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { AtomicCarousel } from "@farmlands/atomic-io";
import { Stack, useMediaQuery, useTheme } from "@mui/material";
import React from "react";
import { useSelector } from "react-redux";

import { usePermission } from "../../hooks/usePermission";
import { TestIds } from "../../testIds";
import { selectConfigByKey } from "../firebase/remote-config/remoteConfig.slice";

import { useAtomic } from "./AtomicProvider";

export const ATOMIC_STREAM_ID_AGREEMENTS =
  process.env.REACT_APP_ATOMIC_STREAM_CONTAINER_ID_AGREEMENTS!;

export const AgreementsCampaignsAtomic = () => {
  const atomicEnabled = useSelector(selectConfigByKey("atomicEnabled"));
  const atomicAgreementsEnabled = useSelector(selectConfigByKey("atomicPromotionsEnabled"));
  const canCreateAgreement = usePermission("SalesAgreements_AgreementCreate").allowed;
  const { atomicReady, onLinkButtonPressed } = useAtomic();
  const theme = useTheme();
  const isSm = useMediaQuery(theme.breakpoints.down("md"));

  const cardWidth = isSm ? (window.innerWidth / 100) * 60 : 354;

  if (!atomicAgreementsEnabled || !atomicEnabled || !atomicReady || !canCreateAgreement) {
    return null;
  }

  return (
    <Stack data-testid={TestIds.feat.agreement.createAgreementCarouselContainer} width="100%">
      <AtomicCarousel
        title=""
        containerId={ATOMIC_STREAM_ID_AGREEMENTS}
        cardWidth={cardWidth}
        hideWithoutItems
        atomicReady={atomicReady}
        onLinkButtonPressed={onLinkButtonPressed}
      />
    </Stack>
  );
};
